import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Login/components/layout";
import EmailSentPage from "../../components/emailSent";
import GuestRoute from "../../components/GuestRoute";

const EmailSentContainer = () => (
  <GuestRoute>
    <main>
      <Helmet title="Email Sent" />
      <Layout>
        <EmailSentPage />
      </Layout>
    </main>
  </GuestRoute>
);

export default EmailSentContainer;